import React, { useContext } from "react";
import {ThemeContext} from "../Context";
import Card from "./Card";

const Details = ({ details }) => {
  const { darkMode } = useContext(ThemeContext);

  //Object to rename the details retrieved by fetchStockDetails. 
  const detailsList = {
    name: "Name",
    country: "Country",
    currency: "Currency",
    exchange: "Exchange",
    ipo: "IPO Date",
    marketCapitalization: "Market Capitalization",
    finnhubIndustry: "Industry",
  };

  //Utility function to format market capitalization correctly.
  const convertMilliontoBillion = (number) => {
    return (number / 1000).toFixed(2);
  };

  return (
    <Card>
      <ul className={`w=full h-full flex flex-col justify-between divide-y-2 px-2 whitespace-nowrap  ${darkMode ? "divide-gray-800": null}`}>
        {Object.keys(detailsList).map((item) => {
          return (
            <li key={item} className="flex-1 flex justify-between items-center">
              <span>{detailsList[item]}</span>
              <span>
                {item === "marketCapitalization"
                  ? `${convertMilliontoBillion(details[item])}`
                  : details[item]}
              </span>
            </li>
          );
        })}
      </ul>
    </Card>
  );
};

export default Details;
